
import { useState, useEffect } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { Customer } from '@/lib/supabase/customers/types';
import { useSaveCustomer } from '../useCustomerForm/useSaveCustomer';

export const useCustomerFormSubmit = (
  customerId: string, 
  onSuccess: () => void, 
  shopId?: string
) => {
  const [formErrors, setFormErrors] = useState<{[key: string]: string}>({});
  const { saving, errors: saveErrors, updateCustomer: saveCustomer } = useSaveCustomer(onSuccess);
  
  // Correction : remplacer useState par useEffect
  useEffect(() => {
    if (saveErrors && Object.keys(saveErrors).length > 0) {
      setFormErrors(saveErrors);
    }
  }, [saveErrors]); // Ajouter saveErrors comme dépendance
  
  const handleSave = async (
    customerData: Partial<Customer>,
    validateForm: () => boolean
  ) => {
    setFormErrors({});
    if (!validateForm()) return null;
    
    try {
      // For new customers, ensure the user has provided a phone number
      if (customerId === 'new' && !customerData.phone) {
        setFormErrors({ phone: 'Le numéro de téléphone est obligatoire' });
        return null;
      }
      
      const result = await saveCustomer(customerId, {
        ...customerData,
        shop_id: shopId || customerData.shop_id,
      });
      
      if (!result) {
        console.log("Error saving customer - no result returned");
      }
      
      return result;
    } catch (error) {
      console.error('Error saving customer:', error);
      return null;
    }
  };
  
  return {
    saving,
    formErrors,
    handleSave,
    setFormErrors,
  };
};
